<template>
  <div>
    <Header :isHome="false"></Header>
    <div class="bg" ref="bg" style="overflow: hidden">
      <div class="container" style="position: relative">
        <img
          src="../../assets/imgs/user/userlevel/userlevelicon.png"
          style="position: absolute; left: -8rem; bottom: -7rem; width: 20rem"
        />
        <div class="row" style="z-index: 1; position: relative">
          <div style="display: flex; flex-direction: column; width: 100%">
            <!-- 会员记录入口 -->
            <div
              style="
                display: flex;
                justify-content: flex-end;
                font-size: 0.8rem;
                color: #000;
                font-weight: 500;
                margin-right: 0.5rem;
              "
            >
              <div
                style="
                  border-radius: 5rem;
                  padding: 0.3rem 1rem;
                  width: fit-content;
                  cursor: pointer;
                "
                class="btn-record"
                @click="touserrecord"
              >
                Membership records
              </div>
            </div>

            <!-- 会员信息 -->
            <div
              class="box1"
              style="
                padding: 1rem 2rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
              v-if="userinfo"
            >
              <div style="display: flex; align-items: center" class="box2">
                <div
                  :style="{ backgroundImage: 'url(' + userinfo.avatar + ')' }"
                  class="img-cover"
                  style="
                    border-radius: 50%;
                    min-width: 5rem;
                    height: 5rem;
                    margin-right: 1.5rem;
                  "
                ></div>
                <div style="display: flex; flex-direction: column; color: #000">
                  <div style="display: flex; align-items: center">
                    <div
                      style="
                        font-size: 1.5rem;
                        margin-right: 0.5rem;
                        font-weight: 500;
                      "
                    >
                      {{ userinfo.username }}
                    </div>
                    <div
                      style="
                        padding: 0.2rem 0.4rem;
                        font-size: 0.7rem;
                        border-radius: 0.2rem;
                        color: #fff;
                      "
                      ref="iconbg"
                    >
                      {{ userinfo.vip.title }} Plans
                    </div>
                  </div>

                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      margin-top: 0.3rem;
                    "
                    v-if="userinfo.vip.id != 1"
                  >
                    <div style="font-size: 0.8rem">
                      Expire date : {{ userinfo.vip.endTime }}
                    </div>

                    <div style="font-size: 0.8rem">
                      You have been a member for {{ userinfo.vip.usedDay }} days
                    </div>

                    <div style="font-size: 0.8rem">
                      the remaining {{ userinfo.vip.overDay }} days
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="btn-gold-liner"
                style="
                  padding: 0.5rem 2rem;
                  border-radius: 10rem;
                  font-size: 1rem;
                  font-weight: bold;
                  cursor: pointer;
                "
                v-if="userinfo.vip.id != 1"
                @click="topay(userinfo.vip)"
              >
                To renew
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <!-- 会员权限展示 -->
      <div class="row" style="margin-bottom: 3rem">
        <div
          class="col-3 main"
          v-for="(item, index) in data"
          :key="index"
          v-if="item.id != 5"
        >
          <div
            class="box hover-up transition-02s"
            style="position: relative; overflow: hidden"
          >
            <div
              style="
                position: absolute;
                right: -1rem;
                top: -1rem;
                width: 6rem;
                height: 6rem;
                border-radius: 50%;
              "
              :style="{ backgroundColor: colorlist[index].color }"
            ></div>
            <div
              style="
                border: 1px solid #eee;
                padding: 0.2rem 0.5rem;
                margin-bottom: 0.5rem;
                width: fit-content;
                border-radius: 5rem;
                font-size: 0.7rem;
              "
              class="hover-bg"
            >
              {{ item.title }} plans
            </div>
            <!-- 金额 -->
            <div
              style="font-size: 1.5rem; font-weight: bold; margin-bottom: 1rem"
            >
              {{ item.price ? "$" + item.price : "Free" }}
            </div>

            <!-- 金额换算 -->
            <div style="margin-bottom: 1rem; font-size: 0.8rem">
              <div v-show="!item.price">No member privileges</div>
              <div v-show="item.price">
                {{ item.title }}
                <span :style="{ color: colorlist[index].color }"
                  >≈ {{ (item.price / item.duration).toFixed(2) }}/day</span
                >
              </div>
            </div>

            <!-- 充值按钮 -->
            <div style="">
              <div
                class="btn-normal btn-hover"
                style="color: #333; font-size: 1rem; font-weight: bold"
                :style="{ backgroundColor: colorlist[index].color }"
                v-show="!item.price"
                @click="tohome"
              >
                Free Use
              </div>
              <div
                class="btn-normal btn-hover"
                style="color: #fff; font-size: 1rem; font-weight: bold"
                :style="{ backgroundColor: colorlist[index].color }"
                v-show="item.price"
                @click="topay(item)"
              >
                Pay
              </div>
            </div>

            <div
              ref="viptext"
              :style="{ height: height ? height + 'px' : '100%' }"
              style="margin-bottom: 1rem; margin-top: 1rem"
            >
              <div
                v-for="(text, textindex) in item.description.split('\n')"
                style="
                  display: flex;
                  align-items: center;
                  margin-bottom: 0.5rem;
                "
              >
                <div
                  style="
                    color: #fff;
                    margin-right: 0.5rem;
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  class="tick-icon"
                ></div>
                {{ text }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 权益表格 -->
      <div class="row" style="flex-direction: column; margin-bottom: 3rem">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            font-size: 2rem;
            font-weight: bold;
            margin-bottom: 2rem;
          "
        >
          <img
            src="../../assets/imgs/user/userlevel/title-left.png"
            style="width: 3rem; height: 3rem"
          />
          <span style="margin-left: -2rem">Compare Plan</span>
        </div>

        <div style="overflow: scroll; width: 100%" class="noscrollbar">
          <!-- <img :src="userlevelimg" style="width: 100%;height: 100%;"> -->
          <!-- 表格 -->
          <div style="display: flex; border: 1px solid #eee">
            <!-- 第一列 -->
            <div style="display: flex; flex-direction: column">
              <div
                class="p1 p-title"
                style="display: flex; background-color: #ececec"
              >
                Access
              </div>
              <div style="background-color: #fff">
                <div class="p1 p-content">Full site search</div>
                <div class="p1 p-content">Circle interaction</div>
                <div class="p1 p-content">Browse information</div>
                <div class="p1 p-content">Online experts appointment</div>
                <div class="p1 p-content">Browse service providers</div>
                <div class="p1 p-content">Browse demands</div>
                <div class="p1 p-content">Demands publishing</div>
                <div class="p1 p-content">Membership period</div>
              </div>
            </div>
            <!-- 第二列 -->
            <div style="display: flex; flex-direction: column">
              <div
                class="p2 p-title"
                style="display: flex; background-color: #efe6d4"
              >
                Free plan
              </div>
              <div style="background-color: #fdfbf4">
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">Max:5 views no filtering</div>
                <div class="p2 p-content">Max:5 views</div>
                <div class="p2 p-content">
                  <div class="p-icon icon-false"></div>
                </div>
                <div class="p2 p-content">Unlimited</div>
              </div>
            </div>
            <!-- 第三列 -->
            <div style="display: flex; flex-direction: column">
              <div
                class="p2 p-title"
                style="display: flex; background-color: #fde8c5"
              >
                Monthly plan
              </div>
              <div style="background-color: #fff8f0">
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">30Days</div>
              </div>
            </div>
            <!-- 第四列 -->
            <div style="display: flex; flex-direction: column">
              <div
                class="p2 p-title"
                style="display: flex; background-color: #fde8c5"
              >
                Quarter plan
              </div>
              <div style="background-color: #fff8f0">
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">90Days</div>
              </div>
            </div>
            <!-- 第五列 -->
            <div style="display: flex; flex-direction: column">
              <div
                class="p2 p-title"
                style="display: flex; background-color: #fde8c5"
              >
                Year plan
              </div>
              <div style="background-color: #fff8f0">
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">
                  <div class="p-icon icon-true"></div>
                </div>
                <div class="p2 p-content">365Days</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 问题模块 -->
      <div class="row" style="margin-bottom: 3rem">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            font-size: 2rem;
            font-weight: bold;
            margin-bottom: 2rem;
          "
        >
          <img
            src="../../assets/imgs/user/userlevel/title-left.png"
            style="width: 3rem; height: 3rem"
          />
          <span style="margin-left: -2rem">FAQS</span>
        </div>
        <Question type="1"></Question>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
import Question from "/src/components/question.vue";
export default {
  data() {
    return {
      data: null,
      userinfo: {
        vip: {
          id: null,
        },
      },
      height: null,

      colorlist: [
        {
          id: 1,
          bg: "linear-gradient(90deg, #DCFFFC 0%, #C1FFFA 100%)",
          color: "#79F2E5",
        },
        {
          id: 2,
          bg: "linear-gradient(90deg, #E2FFFF 0%, #AAD8FF 100%)",
          color: "#65B8FE",
        },
        {
          id: 3,
          bg: "linear-gradient(90deg, #D0E9FF 0%, #AFACFF 100%)",
          color: "#8782FF",
        },
        {
          id: 4,
          bg: "linear-gradient(90deg, #BFD1FF 0%, #84A1FF 100%)",
          color: "#275AFF",
        },
        {
          id: 5,
          bg: "linear-gradient(90deg, #C1FFFA 0%, #3dac7c 100%)",
          color: "#3dac7c",
        },
      ],
      userlevelimg: null,
    };
  },
  components: {
    Header,
    Footer,
    Question,
  },
  methods: {
    getvipinfo() {
      this.request({
        method: "get",
        url: "/gci/vip",
      })
        .then((res) => {
          this.data = res.data.vips;
          this.userlevelimg = res.data.privilegeImage;
          this.$bus.$emit("loading", false);

          // dom元素高度最大值
          this.$nextTick(() => {
            let el = this.$refs.viptext;
            console.info(el);
            let h = 0;
            el.findIndex((key) => {
              if (key.clientHeight > h) {
                h = key.clientHeight;
              }
            });
            this.height = h;
          });
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    tohome() {
      this.$router.push({ name: "home" });
    },
    topay(item) {
      let params = {
        id: item.id,
      };
      this.request({
        method: "post",
        url: "/buyVip",
        data: params,
      })
        .then((res) => {
          //   console.info("res11111", res);
          window.open(res.url);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getuser() {
      this.request({
        method: "get",
        url: "/gci/user/info",
      })
        .then((res) => {
          this.userinfo = res.data;
          this.colorlist.findIndex((key) => {
            if (key.id == this.userinfo.vip.id) {
              // console.info(key)
              this.$refs.bg.style.background = key.bg;
              this.$refs.iconbg.style.background = key.color;
            }
          });
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    touserrecord() {
      this.$router.push({ name: "userrecord" });
    },
  },
  mounted() {
    this.getuser();
    this.getvipinfo();
  },
};
</script>

<style scoped lang="scss">
.bg {
  padding: 5rem 0 3rem;
}
.main {
  padding: 0.5rem;
  margin-top: -3rem;
  .box {
    border: 1px solid #eee;
    border-radius: 1rem;
    background-color: #fff;
    padding: 1rem;
    color: #000;
  }
  .hover-bg {
    background-color: #fff;
  }
  .tick-icon {
    background-image: url("../../assets/imgs/user/userlevel/tick_normal_icon.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
.btn-hover {
  margin-right: 0rem;
}
.btn-hover:hover {
  opacity: 0.9;
}
.btn-record:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

// 表格样式
.p-title {
  font-size: 1rem;
  font-weight: 500;
}
.p-content {
  font-size: 0.8rem;
  font-weight: 500;
  border-bottom: 1px solid #eee;
  min-height: 3rem;
}
.p1 {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  min-width: 15rem;
}
.p2 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  min-width: 14.2rem;
}
.icon-true {
  background-image: url("../../assets/imgs/user/userlevel/icon-true.svg");
}
.icon-false {
  background-image: url("../../assets/imgs/user/userlevel/icon-false.svg");
}
.p-icon {
  width: 1.5rem;
  height: 1.5rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
@media (max-width: 767px) {
  .container {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
  .box1 {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .btn-gold-liner {
    margin-top: 1rem;
  }
  .col-3 {
    max-width: 100%;
    min-width: 100%;
    margin-bottom: 3rem;
  }
  .box2 {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
</style>
